export default {
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/00_TV_clean_box/TV_clean_box${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/megaphone.png'),
  designImageList: [
    {
      number: 1,
      side: 'BOTTOM',
      image: require('../../../parts/megaphone/01.png'),
    },
    {
      number: 2,
      side: 'HANDLE',
      image: require('../../../parts/megaphone/02.png'),
    },
    {
      number: '',
      image: require('../../../parts/megaphone/03.png'),
    },
    {
      number: 3,
      side: 'JOINT',
      image: require('../../../parts/megaphone/04.png'),
    },
    {
      number: '',
      image: require('../../../parts/megaphone/05.png'),
    },
    {
      number: 4,
      side:'MIDDLE',
      image: require('../../../parts/megaphone/06.png'),
    },
    {
      number: 5,
      side:'MIDDLE2',
      image: require('../../../parts/megaphone/07.png'),
    },
    {
      number: 6,
      side: 'SIDE',
      image: require('../../../parts/megaphone/08.png'),
    },
    {
      number: '',
      image: require('../../../parts/megaphone/09.png'),
    },
    {
      number: 7,
      side: 'FRONT',
      image: require('../../../parts/megaphone/10.png'),
    },
    {
      number: 8,
      side: 'BACK',
      image: require('../../../parts/megaphone/11.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/megaphone/12.png'),
  assembleSequenceImages: Array(88)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/38_megaphone/Cheer Megaphone${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/megaphone2.jpg'),
  completeImagePc: require('../../../complete/megaphone2.jpg'),
};


